import { useState } from "react";

import UCalgaryLogo from "../../public/ucalgaryLogo.png";
import Circle from "../LogoSVG/Circle";

export const UCalgaryDesktop = () => {
  return (
    <div className="flex flex-row items-start mb-[65px]">
      <div className="w-[200px] h-[83px] mt-2 overflow-hidden mr-10 bg-white rounded p-2">
        <img
          src={UCalgaryLogo}
          alt="logo"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="flex flex-col justify-start">
        <p className="mb-2 text-[18px] font-medium">
          University of Calgary | Canada
        </p>
        <ul className="text-gray-5">
          <li>
            <div className="flex flex-row ">
              <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
              <p className="text-gray-4">
                Master of Science - MSc | 2025 - 2027
              </p>
            </div>
          </li>
          <li>
            <div className="flex flex-row items-start mt-1.5">
              <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
              <div className="text-gray-4 w-[600px]">
                Supervisors: &nbsp;
                <a
                  className="text-custom-green"
                  href="https://ldklab.github.io"
                  target="_blank"
                >
                  Prof. Lorenzo De Carli
                </a>{" "}
                and{" "}
                <a
                  className="text-custom-green"
                  href="https://calgaryish.com/PI/"
                  target="_blank"
                >
                  Prof. Benjamin Tan
                </a>
              </div>
            </div>
          </li>
          <li>
            <div className="flex flex-row items-start mt-1.5">
              <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
              <div className="text-gray-4 w-[600px]">
                Fully funded MSc position (Sponsor: NSERC/NSF Collaboration)
              </div>
            </div>
          </li>
          <li>
            <div className="flex flex-row items-start mt-1.5">
              <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
              <div className="text-gray-4 w-[500px]">
                Research: LLM Routing for Software Supply Chain Security with Performance and Cost Trade-offs
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
